export const PREFIX = '$header'; // 前缀

export const LOCAL_LANG = `${PREFIX}_lang`; // 本地存储语言的key

export const CAPTCHA_CODE = '40011';
export const TOKEN_INVALID_CODE = '280001';

export const NAV_MIN_WIDTH = 500;
